export function getUserInitials(username?: string | null): string {
  if (!username?.trim()) {
    return '?';
  }

  const localPart = username.split('@')[0]?.trim() || username;
  const parts = localPart.split(/[.\s_-]+/).filter(Boolean);

  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }

  return localPart.substring(0, 2).toUpperCase();
}
